import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import type { FC } from 'react';

import { AUTH_ROUTES } from '@/constants/auth';
import { errorLog } from '@/lib/errorLog';
import { useNavigation, useRouteAccess } from '@/hooks/access';
import { useSignOut } from '@/hooks/auth';
import { usePersonaScreen } from '@/hooks/persona';

import { AppShell } from 'components/layout/AppShell';
import { Forbidden } from 'components/layout/Forbidden';

import type { TAppLayoutProps } from './AppLayout.props';

const AppLayout: FC<TAppLayoutProps> = ({ children }) => {
  const { persona, name } = usePersonaScreen();
  const sections = useNavigation();
  const { isAllowed, isReady } = useRouteAccess();
  const navigate = useNavigate();
  const signOut = useSignOut();

  useEffect(() => {
    errorLog.enable();

    return errorLog.disable;
  }, []);

  const onSignedOut = () => {
    navigate(AUTH_ROUTES.login, { replace: true });
  };

  const onSignOut = () => {
    signOut.mutate(undefined, { onSettled: onSignedOut });
  };

  if (!persona) {
    return null;
  }

  return (
    <AppShell persona={persona} name={name} sections={sections} onSignOut={onSignOut}>
      {isReady && !isAllowed ? <Forbidden /> : children}
    </AppShell>
  );
};

export {
  AppLayout,
};
